import _ from 'lodash'

export class Product {
	constructor (attributes) {
		for (let key in attributes) {
			this[key] = attributes[key]
		}

	}

	static createFromExtra(attributes) {
		let p = new Product(_.merge({}, attributes, attributes.product));
		p.original = attributes
		p.price_type = 'global'
		p.shoppable = true
		p.description = attributes.description
		p.description_content = attributes.product.description
		p.type = 'extra'
		p.original = attributes
		p.original.type = p.type

		return p;
	}

	static createFromRecipe(attributes) {
		let p = new Product(_.merge({}, attributes, attributes.product));
		p.original = attributes
		p.price = (p.sell_out[2]/2).toFixed(2).replace(".", ",")
		p.price_type = 'portion'
		p.description = attributes.description
		p.summary = attributes.description_short
		p.description_content = null;
		p.type = 'recipe'
		p.original = attributes
		p.original.type = p.type
		p.discount = {value: 0, price: p.price}

		return p;
	}
}
